// copyright Joseph W Shelby. Released under the MIT License.

import React from 'react';

class LowSrcImg extends React.Component {  
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    this.replaceLowHigh = this.replaceLowHigh.bind(this);
  }

  componentDidMount() {
    if (this.i.complete) {
      this.replaceLowHigh();
    }
  }

  componentWillUpdate(props) {
    this.state = {
      loaded: false
    };
  }

  replaceLowHigh() {
    var s = this.state;
    if (s.loaded) return;
    s.loaded = true;
    this.setState(s);
  }

  render() {
    const props = Object.assign({}, this.props);
    if (!this.state.loaded) {
      props.src = props.lowsrc;
    }
    delete props.lowsrc;
    return (
      <img {...props} alt={this.i} onLoad={this.replaceLowHigh} ref={(i) => {this.i = i;}}/>
    );
  }
}

export default LowSrcImg;  


// WEBPACK FOOTER //
// ./src/components/item/itemDetailModal/lowsrc.js